export const CURSOR_SIZE = "CURSOR_SIZE";
export const CURSOR_HIDE = "CURSOR_HIDE";
export const DEFAULT_CURSOR_SIZE = 20;
export const MENU_CURSOR_SIZE = 30;
export const BIG_CURSOR_SIZE = 100;
export const TEXT_MODE = "TEXT_MODE";
export const CURSOR_MODE = "CURSOR_MODE";
export const IMAGE_MODE = "IMAGE_MODE";